import { render, staticRenderFns } from "./reservationCancellationApplied.vue?vue&type=template&id=6d4f6e04&scoped=true&"
import script from "./reservationCancellationApplied.vue?vue&type=script&lang=js&"
export * from "./reservationCancellationApplied.vue?vue&type=script&lang=js&"
import style0 from "./reservationCancellationApplied.vue?vue&type=style&index=0&id=6d4f6e04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f6e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VRow,VSelect})
